const FileIcon = () => {
  return (
    <svg
      width="66"
      height="62"
      viewBox="0 0 66 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39.9122 5.52523C38.8872 4.50023 37.1122 5.20023 37.1122 6.62523V15.3502C37.1122 19.0002 40.2122 22.0252 43.9872 22.0252C46.3622 22.0502 49.6622 22.0502 52.4872 22.0502C53.9122 22.0502 54.6622 20.3752 53.6622 19.3752C50.0622 15.7502 43.6122 9.22523 39.9122 5.52523Z"
        fill="#C9C9C9"
      />
      <path
        d="M51.6618 25.475H44.4368C38.5118 25.475 33.6868 20.65 33.6868 14.725V7.5C33.6868 6.125 32.5618 5 31.1868 5H20.5868C12.8868 5 6.6618 10 6.6618 18.925V41.075C6.6618 50 12.8868 55 20.5868 55H40.2368C47.9368 55 54.1618 50 54.1618 41.075V27.975C54.1618 26.6 53.0368 25.475 51.6618 25.475ZM29.1618 44.375H19.1618C18.1368 44.375 17.2868 43.525 17.2868 42.5C17.2868 41.475 18.1368 40.625 19.1618 40.625H29.1618C30.1868 40.625 31.0368 41.475 31.0368 42.5C31.0368 43.525 30.1868 44.375 29.1618 44.375ZM34.1618 34.375H19.1618C18.1368 34.375 17.2868 33.525 17.2868 32.5C17.2868 31.475 18.1368 30.625 19.1618 30.625H34.1618C35.1868 30.625 36.0368 31.475 36.0368 32.5C36.0368 33.525 35.1868 34.375 34.1618 34.375Z"
        fill="#C9C9C9"
      />
      <ellipse cx="51.5502" cy="48" rx="14.0379" ry="14" fill="#2378C8" />
      <path
        d="M56.2464 46.1093L51.5253 41.3882L46.8042 46.1093"
        stroke="white"
        strokeWidth="1.16667"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.5251 54.6105V41.5205"
        stroke="white"
        strokeWidth="1.16667"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FileIcon;
